// src/config/colors.js
export const colors = {
  menuBg: 'rgb(15, 17, 27)',
  menuText: '#bfcbd9',
  menuActiveText: '#409EFF',
  menuHover: '#263445'
}